import axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";

import { USER_TYPES } from "consts";
import { setPatientsConfiguration, setUserToState } from "store/actions";

/////////////////// Fetch user data logic ///////////////////
export const fetchUserData = async (dispatch, logout, setUser) => {
  const currentJwToken = extractJwtTokenFromUrl() || localStorage.getItem('jwtToken');
  if(!currentJwToken) {
    return;
  }

  try{
    const result = await axios.post(`${process.env.REACT_APP_API_URL}/app/auth/login-by-jwt`,{jwtoken:currentJwToken},{ headers: {'Authorization': `Bearer ${currentJwToken}`} })
    const {role, doctor, patient, username, id: userId, token:jwtToken,accessToken} = result.data.data;
    localStorage.setItem('jwtToken', jwtToken)
    const appConfigs = (role === USER_TYPES.PATIENT) ? await axios.get(`${process.env.REACT_APP_API_URL}/app/patient/app-configuration-jwt`,{ headers: {'Authorization': `Bearer ${jwtToken}`} }) : {}//its may just in patient case
    const patientOrDoctorData = doctor || patient || {}
    if(patientOrDoctorData){
      const getUser = {data:{...patientOrDoctorData,userId,username ,accessToken,appConfigs:appConfigs?.data}, type:role||'patient', jwtToken}
      delete getUser.data.peripheralHistory
      Cookies.set('user', JSON.stringify(getUser) , {expires:1} )
      localStorage.setItem('lastEntry',moment().utc().format('YYYY-MM-DD HH:mm'))
      setUser(getUser) //add return of role on api-server-login
      dispatch ( setUserToState(getUser) )
      if(role === USER_TYPES.PATIENT) dispatch( setPatientsConfiguration(patient.id, appConfigs.data) )
    }
  }
  catch (err){
    console.log('Error fetching user data:', err);
    if(err?.response?.data?.objectOrError?.action === 1) {
      console.log('JWT token expired or invalid, logging out.');
      logout();
    }
  }
}

const extractJwtTokenFromUrl = () => {
  //token from url is when an integrator request direct link to portal
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const jwtFromUrl = urlParams.get('token');
  removeJwtTokenFromUrl()
  return jwtFromUrl
}

const removeJwtTokenFromUrl = () => {
  // Get the current URL parts
  const origin = window.location.origin;
  const pathname = window.location.pathname;
  // Construct the new URL without query parameters
  const newUrl = `${origin}${pathname}`;
  //replace url without refresh page
  window.history.replaceState({}, '', newUrl);
}


/////////////////// Multi-tab session management ///////////////////
const TABS_KEY = 'portal_active_tabs'
const PENDING_LOGOUT_KEY = 'portal_pending_logout'
const HEARTBEAT_MS = 5000
const TAB_TTL = HEARTBEAT_MS * 3

const RELOAD_GRACE_MS = 3000

export const markPendingLastTabLogout = (tabId) => {
  try {
    localStorage.setItem(PENDING_LOGOUT_KEY, JSON.stringify({ tabId, at: Date.now() }))
  } catch (e) {
    // ignore
  }
}

export const resolvePendingLastTabLogout = (tabId) => {
  let pending
  try {
    pending = JSON.parse(localStorage.getItem(PENDING_LOGOUT_KEY) || 'null')
  } catch (e) {
    pending = null
  }

  if (!pending || !pending.tabId) {
    return { shouldLogout: false, wasReload: false }
  }

  const age = typeof pending.at === 'number' ? (Date.now() - pending.at) : Number.POSITIVE_INFINITY
  const wasReload = pending.tabId === tabId && age < RELOAD_GRACE_MS

  try {
    localStorage.removeItem(PENDING_LOGOUT_KEY)
  } catch (e) {
    // ignore
  }

  return { shouldLogout: !wasReload, wasReload }
}

export const clearTabSessionState = () => {
  try {
    localStorage.removeItem(TABS_KEY)
    localStorage.removeItem(PENDING_LOGOUT_KEY)
  } catch (e) {
    // ignore
  }
}

export const ensureTabPresence = (tabId) => {
  const tabs = pruneTabs(readTabs())
  const hadActiveTabs = Object.keys(tabs).length > 0
  tabs[tabId] = Date.now()
  writeTabs(tabs)
  return hadActiveTabs
}

export const removeCurrentTab = (tabId) => {
  const tabs = pruneTabs(readTabs())
  delete tabs[tabId]
  writeTabs(tabs)
  return Object.keys(tabs).length === 0
}

export const startHeartbeat = (tabId) => setInterval(() => {
  const tabs = pruneTabs(readTabs())
  tabs[tabId] = Date.now()
  writeTabs(tabs)
}, HEARTBEAT_MS)

const readTabs = () => {
  try {
    return JSON.parse(localStorage.getItem(TABS_KEY)) || {}
  } catch (e) {
    return {}
  }
}

const writeTabs = (tabs) => {
  localStorage.setItem(TABS_KEY, JSON.stringify(tabs))
}

const pruneTabs = (tabs) => {
  const now = Date.now()
  return Object.fromEntries(Object.entries(tabs).filter(([, ts]) => now - ts < TAB_TTL))
}

